import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';
import withAuthorization from '../../Session/withAuthorization';
import {withRouter} from 'react-router-dom';
import {db} from '../../../firebase'
import {Form, FormGroup, Input, Label, Button} from 'reactstrap';
import * as common from '../../../constants/common';
import Spinner from '../../Spinner';
import { toast } from 'react-toastify';
import { functions } from '../../../firebase/firebase';

const updateByPropertyName = (propertyName, value) => () => ({
    [propertyName]: value,
  });

const INITIAL_STATE = {
    username: '',
    newusername:'',
    password: '',
    error: null,
    isLoading: true,
    userId: '',
    passwordOne: '',
    passwordTwo: ''
  };

class EditUserCredentials extends Component {
    constructor(props) {
      super(props);

      this.state = {...INITIAL_STATE};
    }

    componentDidMount(){

        var userId  = this.props.match.params.userId;

        db.onceGetUser(userId).then((usersSnapshot)=>{
                let user = usersSnapshot.val();
                this.setState({
                    username:user.username,
                    newusername:user.username,
                    userId: userId,
                    isLoading:false
                });
        })
    }
    
    onSubmit=(event)=>{
        this.setState(this.setState(updateByPropertyName('isLoading', true)));
        var {userId, newusername, passwordOne } = this.state;
        let email = newusername + common.EMAIL_PREFIX;

        var updateUserCredentials = functions.httpsCallable('updateUserCredentials');

        updateUserCredentials({
            userId:userId,
            email:email,
            password:passwordOne})
        .then((snapshot)=>{
            db.doUpdateUserName(userId, newusername).then(()=>{
                this.setState(this.setState(updateByPropertyName('isLoading', false)));
                toast.success("Vartotojas atnaujintas",{
                    position: toast.POSITION.BOTTOM_RIGHT
                  });
            })
        });

        event.preventDefault();
    }

    render(){

        let { username, newusername, isLoading, passwordOne, passwordTwo } = this.state;

        const isInvalid = (newusername === '' || newusername === username)
        && (passwordOne === '' || passwordTwo === '' || passwordOne !== passwordTwo )

        if(isLoading){
            return <Spinner></Spinner>
        }
        else{
            return(
                <Form onSubmit={this.onSubmit}>
                <FormGroup>
                  <Label>Prisijungimo vardas</Label>
                  <Input
                    value={newusername}
                    onChange={event => this.setState(updateByPropertyName('newusername', event.target.value))}
                    type="text"
                    placeholder="Būtinas laukas"
                  />
                </FormGroup>
                <FormGroup>
                    <Label>Keisti slaptažodį</Label>
                    <Input
                        value={passwordOne}
                        onChange={event => this.setState(updateByPropertyName('passwordOne', event.target.value))}
                        type="password"
                    />
                </FormGroup>
                <FormGroup>  
                <Label>Pakartoti slaptažodį</Label>
                    <Input
                    value={passwordTwo}
                    onChange={event => this.setState(updateByPropertyName('passwordTwo', event.target.value))}
                    type="password"
                />
                </FormGroup>
          
              <div className="create-complain-btn">
                <FormGroup>
                <Button disabled={isInvalid} type="submit">
                    Išsaugoti
                </Button>
                </FormGroup>
              </div>  
              </Form>
            )    
        }
    }
}

const authCondition = (authUser, token) => {
    return !!authUser && token.claims.isAdmin;
};

export default compose(
  withAuthorization(authCondition),
  inject('userStore'),
  withRouter,
  observer,  
)(EditUserCredentials);


// WEBPACK FOOTER //
// ./src/components/Users/UsersCredentials/index.js